import { LitElement, } from 'lit-element';
import { ApolloQuery, html } from '@apollo-elements/lit-apollo';
import { css } from 'emotion';

import '../../components/icon/icon-info';
import '../../components/icon/icon-food';
import '../../components/icon/icon-store';
import '../../components/icon/icon-oil';
import '../../components/icon/icon-theme';
import '../../components/icon/icon-story';
import '../../components/icon/icon-location'
import '../../components/icon/icon-time';
import '../../components/icon/icon-market';
import '../../components/icon/icon-bus';
import '../../components/icon/icon-shelter';
import '../../components/icon/icon-bed';
import '../../components/icon/icon-hotel';
import '../../components/icon/icon-atm';
import '../../components/icon/icon-washer';
import '../../components/icon/icon-shower';
import '../../components/icon/icon-baby';
import '../../components/icon/icon-med';
import '../../components/icon/icon-car-washer';
import '../../components/icon/icon-car-charge';
import '../../components/icon/icon-fix';
import '../../components/icon/icon-spec';
import '../../components/icon/icon-heart';
import '../../components/icon/icon-money';
import '../../components/icon/icon-arrow-down';
import '../../components/icon/icon-g';
import '../../components/icon/icon-d';
import '../../components/icon/icon-gdp';
import '../../components/icon/icon-star';
import '../../components/icon/icon-pencil';

import RestArea from './rest-area.graphql';

export class FoodSwiper extends LitElement {
  static get properties() {
    return {
      tab: { type: String, },
      foodList: { type: Array, },
    };
  }

  constructor() {
    super();

    this.swiper = null;
    this.tab = `PREMIUM`;
    this.foodList = [];
  }  

  createRenderRoot() {
    return this;
  }

  firstUpdated() {
    this.createSwiper();
  }

  disconnectedCallback() {
    this.swiper.destroy();
    this.swiper = null;
    super.disconnectedCallback();
  }

  createSwiper() {
    this.swiper = window.app.swiper.create(this.querySelector(`.swiper-container`), {
      speed: 300,
      slidesPerView: `auto`,
      centeredSlides: true,
      pagination: {
        el: this.querySelector(`.swiper-pagination`),
        type: 'bullets',
      },
    });
  }

  updated(changedProperties) {    
    changedProperties.forEach((oldValue, propName) => {
      if (propName === `tab`) {
        this.swiper.destroy();
        this.createSwiper();
      }
    });
  }

  onClickHeart(event) {
    const { currentTarget } = event;

    currentTarget.active = !currentTarget.active;
  }
  
  render() {
    const list = this.foodList.filter(each => each[this.tab.toLocaleLowerCase()]);

    if(list.length === 0) {
      return html``;
    }

    return html`
      <div class="swiper-container ${this.swiperStyle}" data-centered-slides="true">
        <div class="swiper-wrapper">
          ${this.foodList.map(food => {
            if (!food[this.tab.toLocaleLowerCase()] === true) {
              return null;
            }
            
            return this.foodMenuTemplate({
              type: this.tab,
              name: food.name,
              heartCount: 0,
              foodImgSrc: food.imageUrl,
              foodPrice: food.cost,
            });
          })}
        </div>
        <div class="swiper-pagination"></div>
      </div>
    `;
  }

  foodMenuTemplate(obj = {
    type: this.tab,
    name: `음식 이름`,
    heartCount: 0,
    foodImgSrc: `static/example-image-1.png`,
    foodPrice: 0,
  }) {    
    return html`
    <div class="swiper-slide">
      <span class="ribbon">${obj.type}</span>
      <span class="food-name">${obj.name}</span>
      <span class="heart">
        <icon-heart @click="${this.onClickHeart}"></icon-heart>
        <span class="heart__count">${obj.heartCount}</span>
      </span>
      <img class="food-img" alt="음식 사진" src="${obj.foodImgSrc || null}"/>
      <span class="food-price">
        <icon-money></icon-money>
        ${obj.foodPrice}원
      </span>
    </div>
    `;
  }  

  get swiperStyle() {
    return css`    
    & {
      width: 100%;
      height: 300px;
      overflow: visible;
      margin-bottom: 40px;
    }

    .swiper-slide {
      box-sizing: border-box;
      background: #fff;
      
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      width: 80%;
      border-top-left-radius: 20px;
      border-bottom-right-radius: 20px;
      box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.04);
    }

    .food-img {
      width: 200px;
      height: 200px;
      display: flex;
      text-align: center;
      line-height: 200px;  
      border-radius: 100%;
      padding: 10px;
      box-sizing: border-box;
      align-self: flex-end;
      margin-bottom: 30px;
    }

    .ribbon {
      color: #fff;
      width: 100px;
      height: 20px;
      background-color: #bea36b;
      display: inline-block;
      position: absolute;
      top: 20px;
      left: 0;
      z-index: 1000;

      padding-left: 15px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 20px;
    }

    .ribbon:after {
      content: '';
      position: absolute;
      border-style: solid;
      top: 0px;
      right: -10px;
      border-width: 10px 10px 10px 3px;
      border-color: #bea36b transparent #bea36b #bea36b;
      z-index: -1;
    }

    .food-name {
      position: absolute;
      top: 40px;
      left: 15px;
      font-weight: bold;
      font-size: 16px;
      white-space: nowrap;
      text-overflow: clip;
      height: 25px;
      overflow: visible;
    }

    .heart {
      position: absolute;
      top: 15px;
      right: 10px;

      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;

      icon-heart {
        margin-right: 5px;
        height: 30px;
      }

      [active] + .heart__count {
        color: red;
      }

      .heart__count {
        margin-top: -5px;      
      }
    }

    .food-price {
      position: absolute;
      bottom: 10px;
      width: 100%;
      text-align: right;
      display: flex;
      padding-right: 20px;
      box-sizing: border-box;
      font-size: 18px;
      align-items: center;
      color: #797979;

      icon-money {
        height: 20px;
      }
    }

    .swiper-slide-prev,
    .swiper-slide-next {
      margin-left: 10px;
      margin-right: 10px;
      height: 90%;
      margin-top: 5%;      
    }

    .swiper-pagination-bullets {
      bottom: -30px;
    }

    .swiper-pagination-bullet {
      background: #ddd5c5;
    }

    .swiper-pagination-bullet-active {
      background: #bea36b;
    }
    `;
  }
}

export class BottomTabs extends LitElement {
  static get properties() {
    return {
      activeTab: { type: Number, },
    };
  }

  constructor() {
    super();

    this.activeTab = 0;    
  }  
  createRenderRoot() {
    return this;
  }

  onClickTab() {
    const page = document.querySelector(`page-rest-area`);       

    if (this.activeTab === 0) {
      this.activeTab = 1;
      page.bottomTab = 1;
    } else {
      this.activeTab = 0;
      page.bottomTab = 0;
    }
  }
  
  render() {
    return html`
      <footer class="${this.basicStyles}">
        <button 
          class="button-story"
          @click=${() => this.onClickTab()}
        >
          ${this.activeTab === 0 ?  html`<icon-story></icon-story> 이야기` : html`<icon-info></icon-info> 정보`}
        </button>
      </footer>
    `;
  }

  get basicStyles() {
    return css`
    & {
      position: fixed;
      bottom: 0;
      height: 60px;
      width: 100vw;
      background-color: #fff;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.04);

      display: flex;
      justify-content: flex-end;
      padding: 0 10px;
      box-sizing: border-box;

      z-index: 10000;
    }

    button {
      margin: 0 5px;
      padding: 0;
      outline: none;
      background-color: transparent;
      border: none;
      width: 50px;
      height: 50px;

      display: inline-flex;
      flex-direction: column;
      color: #656565;
      font-size: 12px;
      align-items: center;
      justify-content: center;
      line-height: 80%;
    }
    `;
  }
}

// NOTE: 메인 - 휴게소 페이지
export class PageRestArea extends ApolloQuery {
  static get properties() {
    return {
      activeTab: { type: Number, },
      bottomTab: { type: Number, },
      foodTab: { type: String, },
      foodTabMore: { type: Number, },
      restSort: { type: Number, },
    };
  }

  query = RestArea;
  variables = { 
    id: window.app.views.main.router.currentRoute.params.id || ``,
    reviewLimit: 10,
    reviewOffest: 10,
  };

  constructor() {
    super();
    
    this.activeTab = 0;
    this.bottomTab = 0;
    // TYPE: PREMIUM | RECOMMEND | BEST
    this.foodTab = `PREMIUM`;
    this.foodTabMore = 1;
    this.restSort = 0;
  }

  connectedCallback() {
    this.variables.id = window.app.views.main.router.currentRoute.params.id;
    super.connectedCallback();    
  }

  createRenderRoot() {
    return this;
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  onScrollContents(event) {    
    const { currentTarget } = event;
    const scrollPos = currentTarget.scrollTop || currentTarget.scrollTop;
    const sections = this.querySelectorAll(`section.tab`);
    const sectionsPos = [];
    let activeTab = 0;

    sections.forEach((section)=>{
      sectionsPos.push(section.offsetTop);
    });

    for (const i in sectionsPos) {
      if (sectionsPos[i] <= scrollPos + 160) {
        activeTab = Number(i);
      }
    }

    this.activeTab = activeTab;
  }

  onClickTab(tabName = `info`) {
    this.querySelector(`section.tab-${tabName}`).scrollIntoView({behavior: `smooth`});
  }

  onClickHeart(event) {
    const { currentTarget } = event;

    currentTarget.active = !currentTarget.active;
  }

  async onClickFoodMoreButton() {
    const article = this.querySelector(`section.tab-content`);

    this.foodTabMore += 1;

    await this.updateComplete;
    article.scrollBy({
      top: 350,
      behavior: `smooth`,
    });
  }
  
  render() {
    const { data, } = this;
    const { restArea } = data;

    this.updateComplete.then(() => {
      const title = document.querySelector(".navbar-current .title");

      if (!title) {
        const title = document.querySelector(".page-rest-area .title");

        title.textContent = restArea.name + (this.bottomTab === 0 ? ` 정보` : ` 이야기`);  
        return;
      }

      title.textContent = restArea.name + (this.bottomTab === 0 ? ` 정보` : ` 이야기`);
    });

    // NOTE: bottomTab === 0 : 휴게소 정보, 1: 휴게소 소통
    return html`
    <div class="${this.basicStyles}">
      ${this.tabInfoOrRestStory()}
      <div class="tabs-swipeable-wrap">
        <div class="tabs">

          <div id="tab-1" class="page-content tab tab-active">
            ${this.buttonListTemplate()}
          
            ${this.contentTemplate()}
          </div>          

          <div id="tab-2" class="page-content tab">
            <section class="rest-story">
              ${this.restStoryTemplate()}
            </section>
          </div>
        </div>
      </div>
    </div>
    `;    
  }

  tabInfoOrRestStory() {
    return html`
    <div class="toolbar tabbar toolbar-bottom">
      <div class="toolbar-inner">
        <a href="#tab-1" class="tab-link tab-link-active">기본 정보</a>
        <a href="#tab-2" class="tab-link">휴게소 이야기</a>        
      </div>
    </div>
    `;
  }

  // NOTE: 휴게소 이야기
  restStoryTemplate() {
    // TODO: 정렬 (날짜순 - 최신순, 과거순 / 평점 높은순, 평점 낮은순)
    // TODO: 댓글 리스트 (프로필 / 이름 / 시간 / 종합평점 / 분야평점 / 댓글내용 / + 사진)
    return html`
    ${this.scoreTemplate()}

    ${this.restStory()}

    ${this.writeFabButton()}
    `;
  }

  writeFabButton() {
    return html`
    <div class="fab fab-right-bottom color-yellow ${this.fabStyle()}">
      <a class="icon-wrap" href="/write-review/${this.data.restArea.id}">
        <icon-pencil></icon-pencil>
      </a>
    </div>
    `;
  }

  fabStyle() {
    return css`
    & {
      z-index: 100000;
      --f7-theme-color: #BEA36B;
      --f7-theme-color-rgb: #BEA36B;
      --f7-theme-color-shade: #BEA36B;
      --f7-theme-color-tint: #BEA36B;

      --f7-toolbar-height: 0;
    }

    .icon-wrap > svg {
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    `;
  }

  // NOTE: 종합 평점
  scoreTemplate(score = 4.5) {
    return html`
    <div class="score-box ${this.scoreStyle()}">
      <div class="score-left">
        <span class="top">종합평점</span>
        <span class="middle">${score}</span>
        <span class="bottom">
          ${this.starScoreTemplate(4)}
        </span>
      </div>
      <div class="score-right">   
        <!-- NOTE: 편의제공/시설관리/서비스/청결도 + 별 + 점수 -->
        ${this.namedStarScore(`편의제공`, 3)}
        ${this.namedStarScore(`시설관리`, 3)}
        ${this.namedStarScore(`서비스`, 3)}
        ${this.namedStarScore(`청결도`, 3)}
      </div>
    </div>
    `;
  }

  restStory(title = ``) {
    return html`
    <h2 class="rest-story-title ${this.restStoryTitleStyle()}">
      <span class="title">${title}</span>

      <span class="top-bar__sort">
        <button 
          class="sort ${this.restSort === 0 ? `active` : ``}"
          @click=${() => this.restSort = 0}
        >최신순</button>

        <button 
          class="sort ${this.restSort === 1 ? `active` : ``}" 
          @click=${() => this.restSort = 1}
        >평점 높은순</button>
        <button 
          class="sort ${this.restSort === 2 ? `active` : ``}" 
          @click=${() => this.restSort = 2}
        >평점 낮은순</button>
      </span>
    </h2>
    ${this.data.restArea.reviewList.reviews.length
    ? this.data.restArea.reviewList.reviews.map(review => this.commentTemplate({
      author: review.user.name,
      time: review.user.modifiedAt,
      comment: review.comment,
      profile: review.user.profile,
    }))
    // isBlank Review List
    : html`
    <div class="${this.notExistCommentStyle()}">현재 휴게소의 리뷰가 없습니다</div>
    `}
    `;
  }

  notExistCommentStyle() {
    return css`
    & {
      font-size: 16px;
      padding: 20px;
      font-family: auto;
      color: #bcbcbc;
    }
    `;
  }

  restStoryTitleStyle() {
    return css`
    & {
      margin: 10px;
      display: grid;
      grid-template-columns: 150px auto;
      align-items: center;
    }

    .title {
      margin-left: 10px;
      color: #646464;
      font-weight: bold;
      font-size: 25px;
    }

    .top-bar__sort {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }

    .sort {
      font-size: 11px;
      border: none;
      background-color: transparent;
      white-space: nowrap;
      outline: none;
      position: relative;
      color: #bcbcbc;
      width: min-content;
      margin: 0;
    }

    .sort.active {
      color: #0b0b0b;
      margin: 0 5px;
    }

    .sort.active::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      left: -5px;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #bea36b;
    }
    `;
  }

  scoreStyle() {
    return css`
    & {
      margin-left: auto;
      height: 150px;
      background-color: #fff;
      box-shadow: 10px 5px 16px 0 rgba(190, 163, 107, 0.1);

      display: grid;
      grid-template-columns: 150px 200px;      
      width: 90vw;
      justify-content: flex-end;
      margin: 0 auto;
    }

    .score-left {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .top {
        font-size: 15px;
      }

      .middle {
        font-size: 40px;
      }      
    }    

    .score-right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      & > * {
        margin-bottom: 5px;
      }
    }
    `;
  }

  starScoreTemplate(score = 5) {
    return html`
    <span class="star-score ${this.starScoreStyle()}">
      ${new Array(5).fill(0).map((_each, index) => {
        if (index < score) {
          return html`<icon-star active></icon-star>`;
        }
        return html`<icon-star></icon-star>`
      })}
    </span>
    `;
  }

  starScoreStyle() {
    return css`
    & {
      display: flex;
      justify-content: center;
      align-items: center;
    }    

    icon-star {
      width: 20px;
      height: 20px;
      margin-right: -5px;
    }
    `;
  }

  namedStarScore(name = `평점`, score = 5) {
    return html`
    <div class="${this.namedStarScoreStyle()}">
      <span class="name">${name}</span>
      ${this.starScoreTemplate(score)}
      <span class="score">${score}</span>
    </div>
    `;
  }

  namedStarScoreStyle() {
    return css`
    & {
      display: grid;
      grid-template-columns: 50px auto 50px;
      align-items: center;
      text-align: left;
      width: 100%;
    }

    .name {
      white-space: nowrap;
    }
    `;
  }

  commentTemplate(obj = {
    author: `신혜선`,
    time: `10시간 전`,
    comment: `민혁이 이상형, 여친 급구`,
    profile: `#`,
  }) {
    return html`
    <div class="comment ${this.commentStyle()}">
      <!-- TODO: 글쓴이 + 올린 시각 / 별점 -->
      <div class="top">
        <span class="profile-or-time">
          <span class="author">${obj.author}</span>
          <span class="time">${obj.time}</span>
          <img class="profile-img" src="${obj.profile}" alt="프로필 이미지" />
        </span>
        <span class="score">
          <span class="score__text">4</span>
          ${this.starScoreTemplate(4)}
        </span>
      </div>
      <!-- TODO: 평점: 편의제공/시설관리/서비스/청결도 -->
      <div class="middle">
        ${[`편의제공`, `시설관리`, `서비스`, `청결도`].map(name => {
          return html`
          <div class="service">
            <div>${name}</div>
              ${this.starScoreTemplate(3)}
            </div>      
          </div>
          `;
        })}        
      </div>
      <!-- TODO: 댓글 내용 -->
      <div class="bottom">
        ${obj.comment}
      </div>
    </div>
    `;
  }

  commentStyle() {
    return css`
    & {
      width: 90vw;
      display: grid;
      grid-template-rows: 80px 60px minmax(50px, auto);
      padding-bottom: 20px;
      margin-left: auto;
      margin-bottom: 20px;

      background-color: #fff;
      box-shadow: 3px 7px 10px 0 rgba(0, 73, 145, 0.07);
      border-top-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .top {
      display: grid;
      grid-template-columns: auto 100px;
    }

    .profile-or-time {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 40px;
      position: relative;
    }

    .profile {
      font-size: 20px;
      color: #626262;
    }

    .time {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.59);
    }

    .score {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;      
    }

    .score__text {
      font-size: 25px;
      color: #626262;
    }

    .top, .middle, .bottom {
      margin-left: 10px;
      margin-right: 20px;
    }
    
    .middle {
      border: solid 1px #707070;
      border-top-left-radius: 15px;
      border-bottom-right-radius: 15px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
    }

    .bottom {
      font-size: 13px;
      margin-top: 10px;
      margin-left: 12px;
      line-height: 180%;
      color: #626262;
    }

    .service {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;  

      icon-star {
        margin-right: -8px;
      }
    }

    .profile-img {
      position: absolute;
      width: 50px;
      border-radius: 100%;
      height: 50px;
      object-fit: cover;
      object-position: top;
      left: -60px;
    }
    `;
  }

  buttonListTemplate() {
    return html`
    <!-- NOTE: 탭: 편의 / 먹거리 / 입점 / 주유 / 테마 -->
    <nav class="button-list">
      <button 
        class="button-convenience"
        @click=${() => this.onClickTab(`info`)}
      >
        ${this.activeTab === 0 ?  html`<icon-info active>` : html`<icon-info>`} 정보
      </button>
      <button 
        class="button-food"
        @click=${() => this.onClickTab(`food`)}
      >
      ${this.activeTab === 1 ?  html`<icon-food active>` : html`<icon-food>`} 먹거리
      </button>
      <button 
        class="button-store"
        @click=${() => this.onClickTab(`store`)}
      >
      ${this.activeTab === 2 ?  html`<icon-store active>` : html`<icon-store>`} 입점
      </button>
      <button 
        class="button-oil"
        @click=${() => this.onClickTab(`oil`)}
      >
      ${this.activeTab === 3 ?  html`<icon-oil active>` : html`<icon-oil>`} 주유
      </button>
      <button 
        class="button-theme"
        @click=${() => this.onClickTab(`theme`)}
      >
      ${this.activeTab === 4 ?  html`<icon-theme active>` : html`<icon-theme>`} 테마
      </button>
    </nav>
    `;
  }

  contentTemplate() {
    return html`
    <article 
      class="tab-content"
      @scroll="${this.onScrollContents}"
    >
      ${this.tabInfoTemplate()}
      ${this.tabFoodTemplate()}
      ${this.tabStoreTemplate()}
      ${this.tabOilTemplate()}
      ${this.data.restArea.theme ? this.tabThemeTemplate() : null}
    </article>
    `;
  }

  itemTeplate(obj = {
    icon: html`<icon-market width="30" height="30"></icon-market>`,
    name: `편의 시설명`,
    time: `9:00 - 23:00`,
    desc: ``,
  }) {
    return html`
    <div class="tab__content" title="${obj.desc}">
      <div class="tab__item">
        <span class="item__name">
          ${obj.icon}
          <span class="tab__content__name">${obj.name}</span>
        </span>
        <span class="item__time">
          <!-- TODO: API 받으면서, 현재시간에 따라 색상 변경 -->
          <icon-time width="25" height="25"></icon-time>
          <span>${obj.time}</span>
        </span>
      </div>
    </div>
    `;
  }

  tabInfoTemplate() {
    const { data, error, loading, client } = this;
    const { restArea } = data;

    return html`
    <section class="tab tab-info">
      <h2 class="tab-title"><icon-info active></icon-info> 편의 정보</h2>

      <h3 class="tab-sub-title">기본정보</h3>

      <!-- <section class="tab-section tab__basic-info">
        <icon-info width="20" height="20"></icon-info>
        <p>
          TODO: 휴게소 기본정보 텍스트 API 받기
        </p>
      </section> -->
      <section class="tab-section tab__location-info">
        <icon-location></icon-location>
        <p>
          ${restArea.addr}
        </p>
      </section>
      <section class="tab-section tab__time-info">
        <icon-time></icon-time>
        <p>
          ${this.data.restArea.tel}
        </p>
      </section>

      <h3 class="tab-sub-title ${this.data.restArea?.tel ? `` : `hide`}">편의 시설</h3>

      ${restArea.convenientFacilities.map(data => {
        let icon = html``;

        switch (data.name) {
          case `수유실`:
            icon = html`<icon-baby width="30" height="30"></icon-baby>`;
            break;
          case `ATM`:
            icon = html`<icon-atm width="30" height="30"></icon-atm>`
            break;
          case `내고장특산물`:
            icon = html`<icon-spec width="30" height="30"></icon-spec>`;
            break;
          case `쉼터`:
            icon = html`<icon-shelter width="30" height="30"></icon-shelter>`;
            break;
          case `매점`:
            icon = html`<icon-market width="30" height="30"></icon-market>`;
            break;
          case `샤워실`:
            icon = html`<icon-shower width="30" height="30"></icon-shower>`;
            break;
          case `경정비`:
            icon = html`<icon-fix width="30" height="30"></icon-fix>`;
            break;
          case `휴게텔`:
            icon = html`<icon-hotel width="30" height="30"></icon-hotel>`;
            break;
          case `세탁실`:
            icon = html`<icon-washer width="30" height="30"></icon-washer>`;
            break;
          case `약국`:
            icon = html`<icon-med width="30" height="30"></icon-med>`;
            break;
          case `버스환승`:
            icon = html`<icon-bus width="30" height="30"></icon-bus>`;
            break;
          case `수면실`:
            icon = html`<icon-bed width="30" height="30"></icon-bed>`;
            break;
          case `세차장`:
            icon = html`<icon-car-washer width="30" height="30"></icon-car-washer>`;
            break;
          default:
            icon = html`<icon-market width="30" height="30"></icon-market>`;
        }
        
        return this.itemTeplate({
          icon,
          name: data.name,
          time: `${data.startTime} - ${data.endTime}`,
          desc: data.description,
        })
      })}      
    </section>
    `;
  }

  tabFoodTemplate() {
    const { data, } = this;
    const { restArea } = data;
    const isMoreView = (restArea.foods.length - this.foodTabMore * 4) <= 0;

    return html`
    <section class="tab tab-food">
      <h2 class="tab-title tab-title--food"><icon-food active></icon-food> 휴게소 음식</h2>

      <div class="search-content__top-bar ${this.data.restArea.foods.filter(each => each[this.foodTab]).length !== 0 ? `hide` : ``}">
        <span class="top-bar__sort">
          <button 
            class="sort-street-button ${this.foodTab === `PREMIUM` ? `active` : ``}" 
            @click="${() => this.foodTab = `PREMIUM`}"
          >프리미엄</button>

          <button 
            class="sort-popular-button ${this.foodTab === `RECOMMEND` ? `active` : ``}" 
            @click="${() => this.foodTab = `RECOMMEND`}"
          >추천</button>
          <button 
            class="sort-popular-button ${this.foodTab === `BEST` ? `active` : ``}" 
            @click="${() => this.foodTab = `BEST`}"
          >베스트</button>
        </span>
      </div>
    
      <food-swiper 
        .tab="${this.foodTab}"
        .foodList="${restArea.foods}"
      ></food-swiper>

      <h3 class="tab-sub-title">메뉴 둘러보기</h3>
      <ul class="food-menus">

        ${restArea.foods.map((food, index) => {
          if (index > 4 * this.foodTabMore - 1) {
            return;
          }

          return this.foodMenu2Template({
            name: food.name,
            imgSrc: food.imageUrl,
            price: food.cost,
          })
        })}

        <div 
          class="more-view ${this.moreViewStyle()} ${isMoreView ? `hide` : ``}" 
          @click="${this.onClickFoodMoreButton}"
        >
          <icon-arrow-down></icon-arrow-down>
          더보기
        </div>  
      </ul>        
    </section>
    `;
  }

  moreViewStyle() {
    return css`
    &.hide {
      visibility: hidden;
    }
    `;
  }

  foodMenu2Template(obj = {
    name: `음식 이름`,
    imgSrc: `static/example-image-1.png`,
    price: 0,
  }) {
    return html`
    <li class="food-menu">
      <img class="food-img" src="${obj.imgSrc}" alt="음식 사진"/>

      <div class="food-name">${obj.name}</div>      
      <div class="food-price">${obj.price}원</div>

      <icon-heart width="20" height="20" @click="${this.onClickHeart}"></icon-heart>
    </li>
    `;
  }

  tabStoreTemplate() {
    return html`
    <section class="tab tab-store">
      <h2 class="tab-title tab-title--store"><icon-store active></icon-store> 입점 매장</h2>

      ${this.data.restArea.brandFoods.map(brand => this.itemTeplate({
        icon: ``,
        name: brand.name,
        time: `${brand.startTime} - ${brand.endTime}`,
      }))}
    </section>
    `;
  }

  tabOilTemplate() {
    return html`
    <section class="tab tab-oil">
      <h2 class="tab-title tab-title--oil"><icon-oil active></icon-oil> 주유 정보 ${this.data.restArea.electronicCharge ? `(전기차 충전 가능)` : `(전기차 충전 불가능)`}</h2>

      <div class="tab-contents--oil">
        ${this.oilTankTemplate({
          icon: html`<icon-g></icon-g>`,
          name: `휘발유`,
          price: this.data.restArea?.stationInfos[0]?.gasolinePrice || `-`,
        })}
        ${this.oilTankTemplate({
          icon: html`<icon-d></icon-d>`,
          name: `경유`,
          price: this.data.restArea?.stationInfos[0]?.diselPrice || `-`,
        })}
        ${this.oilTankTemplate({
          icon: html`<icon-gdp></icon-gdp>`,
          name: `LPG`,
          price: this.data.restArea?.stationInfos[0]?.lpgPrice || `-`,
        })}
      </div>
    </section>
    `;
  }

  oilTankTemplate(obj = {
    icon: html`<icon-g></icon-g>`,
    name: `휘발류`,
    price: 0,
  }) {
    return html`
    <div class="oil-tank ${this.oilTankStyle()}">
      <div class="oil-tank__icon">
        ${obj.icon}
      </div>
      <div class="oil-tank__text">
        ${obj.name}
      </div>
      <div class="oil-tank__price">
        <icon-money></icon-money>
        <span>${obj.price}</span>
      </div>
    </div>
    `;
  }

  oilTankStyle() {
    return css`
    & {
      display: grid;
      grid-template-rows: 110px 20px 20px;      
    }

    .oil-tank__icon {
      justify-content: center;
      display: flex;
    }

    .oil-tank__text,
    .oil-tank__price {
      font-size: 16px;
      text-align: center;
      margin-right: 20px;
    }

    .oil-tank__price {
      font-size: 14px;
      align-items: center;
      display: flex;
      justify-content: center;

      icon-money {
        display: contents;
      }
    }
    `;
  }

  tabThemeTemplate() {
    const { data } = this;
    const { restArea } = data;

    return html`
    <section class="tab tab-theme">
      <h2 class="tab-title tab-title--theme"><icon-theme active></icon-theme> 테마 휴게소</h2>
      
      <h3 class="tab-sub-title">${restArea?.theme?.name}</h3>
      <p class="tab-section">
        ${restArea?.theme?.description}
      </p>
    </section>
    `;
  }

  get basicStyles() {
    return css`
    * {
      user-select: none;
    }

    & {
      width: 100vw;
      height: 100vh;

      top: 0;
      left: 0;
      position: absolute;
      background-color: #fcfcfc;

      display: flex;
      flex-direction: column;

      overflow: inherit;
      
      padding-top: calc(var(--f7-navbar-height) + var(--f7-safe-area-top));
      box-sizing: border-box;

      padding-bottom: 50px;
    }

    .hide {
      display: none !important;
    }

    .rest-story {
      padding-top: 20px;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .button-list {
      display: flex;
      flex-direction: row;
      padding: 0 5vw;      
      align-items: center;
      justify-content: space-evenly;
      flex: 0 0 40px;

      border-bottom: 1px solid rgb(224, 224, 224);
      padding-bottom: 10px;
      border-top: 1px solid rgb(224, 224, 224);
      padding-top: 10px;
    }

    .button-list > button {
      margin: 0 5px;
      padding: 0;
      outline: none;
      background-color: transparent;
      border: none;
      width: 50px;
      height: 50px;

      display: flex;
      flex-direction: column;
      color: #656565;
      font-size: 12px;
      align-items: center;
      justify-content: center;
      line-height: 80%;
    }

    .tab-content {
      flex: 1 1 auto;
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
    }

    .tab {
      display: flex;
      flex-direction: column;
      flex: 1 1 100%;
      width: 100%;      
      box-sizing: border-box;
      padding: 0 5vw;
      background-color: #fcfcfc;
      margin-top: 30px;      
    }

    .tab:last-child {
      height: 100%;
    }

    .tab-title {
      font-size: 18px;
      font-weight: bold;
      color: #2b2b2b;
      display: flex;
      align-items: center;
      position: relative;
      margin-top: 20px;
      margin-bottom: 0;
    }

    .tab-title::before {
      content: 'INFO';
      position: absolute;    
      top: -23px;
      left: 6px;
      opacity: 0.15;
      font-family: Raanana;
      font-size: 33px;
      font-weight: bold;      
      color: #646464;
    }

    .tab-sub-title {
      margin: 0;
      margin-top: 10px;
      margin-left: 15px;
      font-size: 16px;
      margin-bottom: 10px;
      font-weight: normal;
      color: #bea36b;
    }

    .tab-section {
      margin-left: 15px;
    }

    .tab-section {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }

    p {
      margin: 0;
      font-size: 12px;
      line-height: 160%;
      color: #626262;
    }

    .tab__content {
      padding-left: 15px;
      margin-bottom: 10px;
    }

    .tab__item {
      display: flex;
      flex-direction: row;
      background-color: #fff;
      border-radius: 5px;
      align-items: center;
      justify-content: space-between;
      height: 50px;

      box-shadow: 3px 3px 10px 0 rgba(190, 163, 107, 0.1);
      padding: 0px 15px;
    }

    .item__time {
      font-size: 16px;
      color: #a2a2a2;
    }

    .item__time,
    .item__name {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .item__name > span {
      margin-left: 5px;
    }

    .tab__content__name {
      font-size: 18px;
      color: #383838;
    }

    .tab-title--food::before {
      content: 'FOOD';
    }

    .tab-title--store::before {
      content: 'STORE';
    }

    .tab-title--oil::before {
      content: 'OIL';
    }

    .tab-title--theme::before {
      content: 'THEME';
    }

    icon-time {
      height: 25px;
    }

    .search-content__top-bar {
      display: flex;
      flex-direction: row;
      height: 30px;
      align-items: center;
      justify-content: flex-end;
      padding-left: 25px;
      padding-right: 10px;
      margin-bottom: 10px;
    }
    
    .top-bar__sort {
      display: flex;
      flex-direction: row;
    }

    .sort-street-button,
    .sort-popular-button {
      font-size: 11px;
      border: none;
      background-color: transparent;
      white-space: nowrap;
      outline: none;
      position: relative;
      color: #bcbcbc;
      width: auto;
    }

    .sort-street-button.active,
    .sort-popular-button.active {
      color: #0b0b0b;      
      margin-left: 5px;
    }

    .sort-street-button.active::after,
    .sort-popular-button.active::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      left: -5px;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #bea36b;      
    }

    .food-menus {
      list-style: none;      

      padding: 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      justify-items: center;
      overflow: visible;
      grid-gap: 10px;
    }

    .food-menu {    
      flex: 0 0 40vw;
      height: calc(40vw + 20px);
      width: 40vw;      
      position: relative;
      z-index: 1;
    }

    .food-menu:before {
      content: '';
      position: absolute;
      top: 30%;
      width: 100%;
      height: 80%;
      background-color: #fff;
      box-shadow: 3px 3px 10px 0 rgba(190,163,107,0.1);
      border-radius: 5px;
      z-index: -1;
    }

    .food-img {
      width: 40vw;
      height: 40vw;
      display: flex;
      text-align: center;
      line-height: 200px;  
      border-radius: 100%;
      padding: 15px;
      box-sizing: border-box;
      align-self: flex-end;
      margin-bottom: 30px;

      padding: 10px;
      object-fit: cover;
    }

    .food-name {
      position: absolute;
      bottom: 10px;
      font-weight: bold;
      left: 10px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 30vw;
    }

    .food-menu icon-heart {
      position: absolute;
      bottom: 7px;
      font-weight: bold;
      right: 10px;
    } 
    
    .food-price {
      position: absolute;
      bottom: -10px;
      left: 10px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 30vw;
    }

    .more-view {
      grid-column: span 2;
      width: 100%;
      text-align: center;
      margin-top: 20px;
    }

    .more-view:hover {
      color: #666;
    }

    .tab-contents--oil {
      display: grid;
      grid-template-columns: repeat(3, 33%);
      width: 100%;
    }

    .toolbar {
      display: flex;
      flex: 0 0 50px;
    }

    .toolbar::before,
    .toolbar::after {
      display: none;
    }

    .page-content.tab {
      margin-top: 0;
      overflow: hidden;
      display: flex;
      padding: 0;
    }

    .page-content.tab {
      display: none;
    }

    .page-content.tab.tab-active {
      display: flex;
    }

    .tab-link-active {
      color: #c7a475;      
    }

    .toolbar .tab-link-highlight {
      bottom: 0;
      top: auto;
      background-color: #c7a475;
    }
    `;
  }
}

customElements.define('food-swiper', FoodSwiper);
customElements.define('bottom-tabs', BottomTabs);
customElements.define('page-rest-area', PageRestArea);